'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StudentController = function () {

  /*@ngInject*/
  function StudentController($http, $scope, Modal, JSONToCSVConvertor) {
    _classCallCheck(this, StudentController);

    this.$http = $http;
    this.Modal = Modal;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
  }

  _createClass(StudentController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.grab();

      this.$http.get('/api/students/active').then(function (response) {
        _this.actives = response.data;
      });

      this.$http.get('/api/icons').then(function (response) {
        _this.icons = response.data[0] || {
          first: '',
          second: '',
          third: '',
          fourth: '',
          year12: ''
        };
      });
      this.prices = ['$60', '$70', '$80'];
    }
  }, {
    key: 'export',
    value: function _export(data) {

      data = data.map(function (student) {
        return {
          'Full Name': student.firstName + ' ' + student.lastName,
          'First Name': student.firstName || ' ',
          'Last Name': student.lastName || ' ',
          'Client Full Name': student.clientFirstName + ' ' + student.clientLastName,
          'Client First Name': student.clientFirstName || ' ',
          'Client Last Name': student.clientLastName || ' ',
          'Email': student.clientEmail || ' ',
          'Phone': student.clientPh || ' ',
          'Grade': student.grade || ' ',
          'Subjects': student.subjects || ' ',
          'CRM ID': student.crmID || ' ',
          'Is Active': student.isActive || 'false',
          'Is Tertiary': student.isTertiary || 'false'
        };
      });

      this.JSONToCSVConvertor(data, 'Student Export', true);
    }
  }, {
    key: 'grab',
    value: function grab() {
      var _this2 = this;

      this.$http.get('/api/students').then(function (response) {
        _this2.students = response.data;
      });
    }
  }, {
    key: 'mergeNames',
    value: function mergeNames(student) {
      var name = student.firstName + ' ' + student.lastName;
      if (student.clientFirstName || student.clientLastName) {
        name += ' - ' + student.clientFirstName + ' ' + student.clientLastName;
      }
      return name;
    }
  }, {
    key: 'addStudent',
    value: function addStudent(newStudent) {
      var _this3 = this;

      if (newStudent) {
        newStudent.fullName = this.mergeNames(newStudent);
        this.$http.post('/api/students', newStudent).then(function (res) {
          _this3.grab();
          _this3.error = '';
        }).catch(function (res) {
          _this3.error = JSON.stringify(res.data, null, '\t');
        });
      }
    }
  }, {
    key: 'patchStudent',
    value: function patchStudent(student, callback) {
      var _this4 = this;

      if (student) {
        student.fullName = this.mergeNames(student);
        this.$http.put('/api/students/' + String(student._id), student).then(function (res) {
          _this4.grab();
          _this4.error = '';
          callback();
        }).catch(function (res) {
          console.log(res);
          _this4.error = JSON.stringify(res.data, null, '\t');
        });
      }
    }
  }, {
    key: 'openModal',
    value: function openModal(student) {
      this.Modal.editStudent(student);
    }
  }]);

  return StudentController;
}();

exports.default = StudentController;


// WEBPACK FOOTER //
// ./client/app/admin/student/student.controller.js